import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations'

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './shared/interceptors/token.interceptor';
import { busyInterceptor } from './shared/interceptors/busy.interceptor';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, ...[withViewTransitions(), withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })]),
    provideHttpClient(withInterceptors([tokenInterceptor, busyInterceptor, errorInterceptor])),
    provideToastr({
      progressAnimation: 'decreasing',
      positionClass: 'toast-bottom-right',
      progressBar: true
    }),
    provideAnimations()
  ]
};
